import {isFalse, isTrue} from "../../libs/utils/epic.utils";

export class CatalogDto {

  public id!: string;
  public name!: string;
  public readonly source: string = 'CUSTOM';
  public readonly enabled!: boolean;
  public externalId: string | undefined;
  public readonly hasCredentials!: boolean;

  constructor(init?: Partial<CatalogDto> | undefined) {
    Object.assign(this, init);
  }

  public isEditable(): boolean {
    return this.isEnabled() && this.source === 'CUSTOM';
  }

  public notEditable(): boolean {
    return !this.isEditable();
  }

  public isEnabled(): boolean {
    return isTrue(this.enabled);
  }

  // Used in Catalog-List
  // noinspection JSUnusedGlobalSymbols
  public notEnabled(): boolean {
    return isFalse(this.enabled);
  }
}
